import { get, set } from 'lodash';

import { ENTITY_TYPE, FIELD_PATHS } from '@funnels/constants';
import { BrokerInterviews, FormValuesPostProductSelect, PostProductSelectContract } from '@funnels/types';

import { INITIAL_BROKER_INTERVIEW } from './initialFormValues';

export function setBrokerInterviewInitialValues(formValues: FormValuesPostProductSelect, applicationId: string) {
  const postProductSelects = get(formValues, FIELD_PATHS.POST_PRODUCT_SELECTS(), []) as PostProductSelectContract[];
  const brokerInterviews = get(formValues, FIELD_PATHS.BROKER_INTERVIEWS(), []) as BrokerInterviews[];
  const brokerInterviewsToBeCreated: BrokerInterviews[] = [];

  postProductSelects
    .filter(
      (pps) =>
        get({ postProductSelect: [pps] }, FIELD_PATHS.POST_PRODUCT_SELECT_ENTITY_TYPE(0)) === ENTITY_TYPE.COMPLIANCE
    )
    .forEach((pps) => {
      const hasBrokerInterview = brokerInterviews.some(
        (brokerInterview) =>
          get({ brokerInterviews: [brokerInterview] }, FIELD_PATHS.BROKER_INTERVIEW_APPLICATION_ID(0)) === applicationId
      );
      //initialize
      if (!hasBrokerInterview) {
        brokerInterviewsToBeCreated.push(INITIAL_BROKER_INTERVIEW(applicationId));
      }
    });

  set(formValues, FIELD_PATHS.BROKER_INTERVIEWS(), [...brokerInterviews, ...brokerInterviewsToBeCreated]);
}
